export default __webpack_public_path__ + "static/media/DB_logo_white_rgb_100px.9637160f.svg";